module.exports = __webpack_public_path__ + "assets/cfb0be653d6b382e810bd9b4c22e85f1.mp3";